<template>
 <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <g clip-path="url(#clip0_258_5383)">
        <path d="M44 12C44 9.8 42.2 8 40 8H8C5.8 8 4 9.8 4 12V36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V12ZM40 12L24 21.98L8 12H40ZM40 36H8V16L24 26L40 16V36Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_258_5383">
        <rect width="48" height="48" fill="white"/>
        </clipPath>
        </defs>
        </svg>
</template>

<script>
export default {
   name: 'Mail',
}

</script>